module.exports = __webpack_public_path__ + "img/5_ngung_xu_ly.bb8f5bca.png";